import type { FilterUrlParams } from '../types';

// NOTE: Changing these param values will break pre-existing deep links!
export const LABELS_PARAM = 'labels';
export const CROSSOVER_PARAM = 'crossover';
export const ON_ROSTER_PARAM = 'on_roster';
export const SEARCH_PARAM = 'search';

export function parseFiltersFromUrlParams(
  urlParams: URLSearchParams,
): FilterUrlParams {
  const labels = urlParams.get(LABELS_PARAM);
  const crossover = urlParams.get(CROSSOVER_PARAM);
  const onRoster = urlParams.get(ON_ROSTER_PARAM);
  const searchText = urlParams.get(SEARCH_PARAM);

  return {
    labelIds: labels?.split(',').map(Number) ?? [],
    isCrossover: crossover === 'true',
    isOnRoster:
      onRoster === null || !['true', 'false'].includes(onRoster)
        ? undefined
        : JSON.parse(onRoster),
    searchText: searchText || undefined,
  };
}

// Function takes a set of FilterUrlParams and returns URLSearchParams.
export function formatFiltersToUrlParams(
  filters: Partial<FilterUrlParams>,
): URLSearchParams {
  const newUrlParams = new URLSearchParams();

  if (filters.labelIds && filters.labelIds.length > 0) {
    newUrlParams.set(LABELS_PARAM, filters.labelIds.join(','));
  }

  if (filters.isCrossover) {
    newUrlParams.set(CROSSOVER_PARAM, `${filters.isCrossover}`);
  }

  if (filters.isOnRoster !== undefined) {
    newUrlParams.set(ON_ROSTER_PARAM, `${filters.isOnRoster}`);
  }

  if (filters.searchText) {
    newUrlParams.set(SEARCH_PARAM, filters.searchText);
  }

  return newUrlParams;
}
